import React, { useEffect, useState } from "react";

import { FilterListCheckbox } from "@app/scripts/reactify/filters/FilterListCheckbox";
import { FilterListSwatch } from "@app/scripts/reactify/filters/FilterListSwatch";
import { FilterSortDrawerItem } from "@app/scripts/reactify/filters/FilterSortDrawerItem";

import type { FilterListProps, Swatches } from "@app/scripts/types";

export const FilterList: React.FC<FilterListProps> = (props) => {
  const [swatches, setSwatches] = useState<Swatches>([]);

  useEffect(() => {
    try {
      const script = document.querySelector("[data-swatchesjson]");
      if (!script) {
        return console.error("No JSON swatch script found");
      }
      const json = JSON.parse(script.innerText.replace("\n", ""));
      setSwatches(json);
    } catch (e) {
      console.error("JSON error", e);
    }
  }, []);

  return (
    <FilterSortDrawerItem
      id={props.filter.id}
      title={props.filter.name}
      checked={!!props.filterListProps.totalSelected}
    >
      <div className="rs__filter">
        {props.filter.displayView === "list" ? <FilterListCheckbox {...props} className="rs__list" /> : null}
        {props.filter.displayView === "check" ? <FilterListCheckbox {...props} className="rs__check" /> : null}
        {props.filter.displayView === "swatch" ? (
          <FilterListSwatch {...props} swatches={swatches} className="rs__swatch" />
        ) : null}
        {props.filter.displayView === "box" ? <FilterListCheckbox {...props} className="rs__box" /> : null}
      </div>
    </FilterSortDrawerItem>
  );
};
